const ACTIVE_HIGHLIGHT_COLOR = 'rgba(48, 196, 172, 0.9)';
const BUFFER_PAGES = 5;
const DEFAULT_PAGE_HEIGHT = 792;
const DEFAULT_PAGE_WIDTH = 612;
const HIGHLIGHT_COLOR = 'rgba(242, 232, 119, 0.9)';
const SEARCH_HIGHLIGHT_COLOR = 'rgba(196, 181, 253, 0.8)';

export {
  ACTIVE_HIGHLIGHT_COLOR,
  BUFFER_PAGES,
  DEFAULT_PAGE_HEIGHT,
  DEFAULT_PAGE_WIDTH,
  HIGHLIGHT_COLOR,
  SEARCH_HIGHLIGHT_COLOR,
};
